// import useSWR from 'swr';
// import { Application } from '../ApiEntreprise';
// import axios from 'axios';

// const API_BASE_URL = import.meta.env.VITE_API;

// const fetcher = (url: string) => axios.get(url, {
//   headers: {
//     Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//   },
// }).then(res => res.data.data);

// export const useApplications = (companyId: number) => {
//   const { data, error, isLoading } = useSWR<Application[]>(
//     `${API_BASE_URL}/Company/${companyId}/applications`,
//     fetcher
//   );

//   return {
//     applications: data || [],
//     isLoading,
//     isError: error,
//   };
// };
import useSWR from 'swr';
import { Application } from '../../../../api/ApiEntreprise';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API;

const fetcher = async (url: string) => {
  try {
    const response = await axios.get(url, {
      // headers: {
      //   Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      // },
      withCredentials:true,
    });
    // Vérifier que la réponse contient un tableau
    const data = response.data.data;
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching applications:', error);
    return []; // Retourner un tableau vide en cas d'erreur
  }
};

export const useApplications = (companyId: number) => {
  // Ne pas effectuer de requête si companyId est invalide (0 ou négatif)
  const shouldFetch = companyId > 0;

  const { data, error, isLoading } = useSWR<Application[]>(
    shouldFetch ? `${API_BASE_URL}/Company/${companyId}/applications` : null,
    fetcher
  );

  return {
    applications: Array.isArray(data) ? data : [],
    isLoading,
    isError: error,
  };
};